import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { InputWrapper } from '@chegg-ui/input-wrapper';
import { BasicStyledTextarea } from '../styles';
var Textarea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var inputId = props.inputId,
      errorText = props.errorText,
      className = props.className,
      labelText = props.labelText,
      visuallyHideLabel = props.visuallyHideLabel,
      helperText = props.helperText,
      width = props.width,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      givenOnChange = props.onChange,
      dataTest = props['data-test'],
      remainingInputProps = _objectWithoutProperties(props, ["inputId", "errorText", "className", "labelText", "visuallyHideLabel", "helperText", "width", "adjustToBackgroundColor", "onChange", "data-test"]);

  return /*#__PURE__*/React.createElement(InputWrapper, {
    inputId: inputId,
    className: className,
    labelText: labelText,
    visuallyHideLabel: visuallyHideLabel,
    errorText: errorText,
    helperText: helperText,
    width: width,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(BasicStyledTextarea, _extends({}, remainingInputProps, {
    id: inputId,
    ref: ref,
    onChange: function onChange(e) {
      return givenOnChange(e.target.value);
    },
    "data-test": dataTest || inputId
  })));
});
Textarea.displayName = 'Textarea';
export default Textarea;